import React, {Fragment} from "react";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {withRouter} from "react-router-dom";
import "./ManagedAgentsSearch.css";
import ManagedAgentService from "../../services/managedagentonboarding/ManagedAgentService";
import AgentCreate from "./AgentCreate";
import {COLUMN_CONFIG} from "./AgentsTableConfig";
import CustomPaginatedDataTableComponent from "../../components/CustomPaginatedDataTableComponent";
import SearchInputGroup from "../../components/SearchInputGroup";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import QueryStringUtils from "../../utils/QueryStringUtils";
import ToastHelper from "../../utils/ToastHelper";
import UserSessionService from "../../services/UserSessionService";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import ManagedAgentView from "./ManagedAgentView";

const NEW_BUTTON_TEXT = "New"
const VIEW_SCREEN = {
    index: "index",
    newPage: "new",
    managedAgentView: "view"
};

class AgentIndex extends React.Component {
    constructor(props) {
        super(props);

        this.searchRef = null;
        this.tableRef = null;

        this.props.changeHeader("My Agents");
        this.baseUrl = "/agents";
        this.managerId = UserSessionService.getUser().user.id;

        this.state = {
            viewMode: this.getDefaultViewState(),
            managedAgents: [],
            loading: true,
            viewId: QueryStringUtils.getQueryStringValue('id'),

        };

        this.handleSubmit = this.handleSubmit.bind(this);

    }

    getDefaultViewState() {
        let view_state = QueryStringUtils.getHashValue() || VIEW_SCREEN.index;
        if (view_state === VIEW_SCREEN.newPage) return VIEW_SCREEN.newPage;
        if (view_state === VIEW_SCREEN.managedAgentView) return VIEW_SCREEN.managedAgentView;
        return VIEW_SCREEN.index
    }


    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let headers = this.tableRef === null ? {} : this.tableRef.getHeaders();
        let values = this.searchRef === null ? {search: ""} : this.searchRef.getValues();

        ManagedAgentService.searchManagedAgents(values.search, this.managerId, headers).then(response => {
            if (Array.isArray(response.body)) {
                let totalSize = response.headers.get("X-Total-Records");
                this.setState({
                    managedAgents: response.body,
                    totalSize: parseInt(totalSize, 10),
                    loading: false
                });
            } else {
                ToastHelper.error(response);
            }
        });
    }

    onCreateClick() {
        this.props.history.push(this.baseUrl + "#" + VIEW_SCREEN.newPage)
        this.setState({viewMode: VIEW_SCREEN.newPage})
    }

    onItemClick(item) {
        this.props.history.push(this.baseUrl + "#" + VIEW_SCREEN.managedAgentView + "&id=" + item.id)
        this.setState({
            viewMode: VIEW_SCREEN.managedAgentView,
            viewId: item.id,
        });
    }

    btnBackClick() {
        this.props.history.push(this.baseUrl)
        this.setState({
            viewMode: VIEW_SCREEN.index,
            viewId: 0
        });
        this.loadData()
    }

    handleSubmit() {
        this.tableRef.resetPage();
        this.loadData();
    }

    render() {
        if (this.state.viewMode === VIEW_SCREEN.index)
            return this.renderManagedAgentsIndex()
        else if (this.state.viewMode === VIEW_SCREEN.newPage)
            return this.renderManagedAgentsNew()
        else if (this.state.viewMode === VIEW_SCREEN.managedAgentView)
            return this.renderManagedAgentsView()
    }

    renderManagedAgentsIndex() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Row className="justify-content-center">
            <Fragment>
                <Col md="10">
                    <Card className="p-2 agentContainer">
                        <CardHeader>
                            My Agents
                        </CardHeader>
                        <CardBody>
                            {this.state.viewMode === VIEW_SCREEN.index && this.renderSearchTable()}
                        </CardBody>
                    </Card>
                </Col>
            </Fragment>
        </Row>
    }

    renderSearchTable() {
        return <Fragment>
            <CustomPaginatedDataTableComponent
                ref={ref => this.tableRef = ref}
                tableColumnConfig={COLUMN_CONFIG}
                tableData={this.state.managedAgents}
                totalRecords={this.state.totalSize}
                onHeadersChange={this.loadData.bind(this)}
                onRowClick={(item) => this.onItemClick(item)}
                createSearchGroup={() => {
                    return <SearchInputGroup
                        ref={ref => this.searchRef = ref}
                        onSubmit={this.handleSubmit}
                        searchFields={[
                            {searchKey: "search", placeholder: "Search"}
                        ]}
                    />
                }}
                createCustomButtonGroup={() => {
                    return (
                        <div className={"mobile_register_button_div"}>
                            <SFXButtonComponent
                                className={"mobile_register_button"}
                                onClick={() => this.onCreateClick()}>
                                {NEW_BUTTON_TEXT}
                            </SFXButtonComponent>
                        </div>
                    )
                }}/>
        </Fragment>
    }

    renderManagedAgentsView() {
        return <Fragment>
            <ManagedAgentView
                agentData={this.state.managedAgents}
                agentId={(this.state.viewId)}
                onRefreshPage={this.loadData.bind(this)}
                btnBackClick={this.btnBackClick.bind(this)}/>
        </Fragment>

    }

    renderManagedAgentsNew() {
        return <AgentCreate
            viewId={this.state.viewId}
            btnBackClick={this.btnBackClick.bind(this)}
            isMobile={this.props.isMobile}
        />
    }
}


export default withRouter(AgentIndex);